import BaseService from "../BaseService";
import {
  Offer,
  OfferOrderBy,
  OfferParams,
  OfferStatus,
} from "../../stores/OfferStore/types";

class OfferService extends BaseService {
  fetchLawyerOffers(lawyerId: string): Promise<Offer[]> {
    return this.fetch<Offer[]>("offers", {
      lawyerId: lawyerId,
    });
  }

  fetchUserOffers(userId: string): Promise<Offer[]> {
    return this.fetch<Offer[]>("offers", {
      userId: userId,
    }).then((offers) =>
      offers.map((offer) => ({
        ...offer,
        user: (offer as any).user?.[0] || offer.user,
        lawyer: (offer as any).lawyer?.[0] || offer.lawyer,
      }))
    );
  }

  async fetchOffer(id: string): Promise<Offer> {
    return this.fetch<Offer>(`offers/${id}`).then((offer) => ({
      ...offer,
      user: (offer as any).user?.[0] || offer.user,
      lawyer: (offer as any).lawyer?.[0] || offer.lawyer,
    }));
  }

  submitOffer(offer: OfferParams): Promise<Offer> {
    return this.post<Offer, OfferParams>("offer", offer);
  }

  updateOffer(offer: OfferParams): Promise<Offer> {
    return this.put<Offer, OfferParams>(`offers/${offer.id}`, offer);
  }

  replyOffer(id: string, status: OfferStatus): Promise<Offer> {
    return this.put<Offer, { status: OfferStatus }>(`replyOffer/${id}`, {
      status,
    }).then((offer) => ({
      ...offer,
      user: (offer as any).user?.[0] || offer.user,
      lawyer: (offer as any).lawyer?.[0] || offer.lawyer,
    }));
  }

  abortOffer(id: string): Promise<Offer> {
    return this.put<Offer, null>(`abortOffer/${id}`).then((offer) => ({
      ...offer,
      user: (offer as any).user?.[0] || offer.user,
      lawyer: (offer as any).lawyer?.[0] || offer.lawyer,
    }));
  }

  searchOffers(
    keyword: string,
    orderBy: OfferOrderBy,
    size: number,
    page: number,
    status: OfferStatus
  ): Promise<{ offers: Offer[]; count: number }> {
    return this.fetch<{ offers: Offer[]; count: number }>("searchOffers", {
      keyword,
      orderBy,
      page: page.toString(),
      limit: size.toString(),
      status,
    }).then((result) => ({
      offers: result.offers.map((offer) => ({
        ...offer,
        id: (offer as any)._id || offer.id,
        user: (offer as any).user?.[0] || offer.user,
        lawyer: (offer as any).lawyer?.[0] || offer.lawyer,
      })),
      count: result.count,
    }));
  }
}

export default OfferService;
